import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

primaryImageStyles.primaryImage = mergeToNew(primaryImageStyles.primaryImage, {
    centeringWrapper: {
        css: css`
            height: 380px;
            border-radius: 12px;
            border: 1px solid ${getColor("common.border")};
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
        `,
    },
    img: {
        style: {
            height: "auto",
            maxHeight: "380px",
            width: "auto",
            maxWidth: "100%",
        },
    },
});

primaryImageStyles.fullPrimaryImageModal = mergeToNew(primaryImageStyles.fullPrimaryImageModal, {
    cssOverrides: {
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: initial !important;
            width: 500px;
            max-width: 500px !important;
        `,
        modalContent: css`
            > div {
                &:nth-of-type(1) {
                    height: 380px;
                    max-height: 380px;
                    width: 100%;
                }
            }
        `,
    },
});

primaryImageStyles.fullPrimaryImage = mergeToNew(primaryImageStyles.fullPrimaryImage, {
    img: {
        css: css`
            width: auto;
            max-height: 100%;
        `,
    },
});

primaryImageStyles.imageCarousel = mergeToNew(primaryImageStyles.imageCarousel, {
    mainContainer: {
        css: css`
            margin-top: 18px;
        `,
    },
    carouselSlide: {
        css: css`
            flex: 0 0 ${100 / 4}%;
            padding: 0;
            position: relative;
            > div {
                padding-top: 0;
                button {
                    width: 100%;
                }
            }
        `,
    },
    image: {
        css: css`
            max-height: 80px;
            height: 80px;
            width: 100%;
            padding: 5px;
            border-radius: 8px;
            border: 1px solid ${getColor("common.border")};
            > img {
                height: auto;
                width: auto;
                max-height: 100%;
                max-width: 100%;
            }
        `,
    },
    selectedImage: {
        css: css`
            max-height: 80px;
            height: 80px;
            width: 100%;
            padding: 5px;
            border-radius: 8px;
            border: 2px solid ${getColor("common.accent")};
            > img {
                height: auto;
                width: auto;
                max-height: 100%;
                max-width: 100%;
            }
        `,
    },
});
